<template>
  <div
  class="d-flex justify-center">
    <basic-badge :value="!isEmpty ? attachments.length : 0">
      <icon-button
      @click="$emit('click')"
      :src="editable ? 'file-document-edit' : 'file-eye'"
      color="amber"
      :disabled="disableOnEmpty && isEmpty"/>
    </basic-badge>
  </div>
</template>

<script>
import BasicBadge from '@/components/common/BasicBadge'
import IconButton from '@/components/btns/IconButton'
export default {
  components: {
    BasicBadge,
    IconButton
  },
  props: {
    attachments: {
      type: Array,
      required: true
    },
    disableOnEmpty: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEmpty() {
      return this.attachments === null || this.attachments === undefined || this.attachments.length === 0
    }
  }
}
</script>

<style>

</style>